import React from 'react';
import { Dropdown } from "react-bootstrap";
import CsvDownloader from "react-csv-downloader";
import { useReactToPrint } from "react-to-print";
import { sanitizeRows } from "utils/exportSanitize";
import CSVIcon from "../../assets/icons/CSV.svg";
import XLSIcon from "../../assets/icons/XLS.svg";
import ExportIcon from "../../assets/media/svg/icons/Files/Export-blue.svg";
import AngleDown from "../../assets/media/svg/icons/Navigation/Angle-down.svg";
import "./index.scss";
import { fontFamilies } from "theme/fontConfig";
const ExportOptions = ({
  columns,
  datas,
  downloadExcel,
  isLoading,
  tableContainerRef,
  setLoading,
  reportFileNameHandler,
  disabled = false,
  printHandler,
  buttonStyle = {},
  showPrint = true
}) => {



  const printPdfHandler = useReactToPrint({
    content: () => tableContainerRef.current,
    documentTitle: reportFileNameHandler(),
    onBeforeGetContent: () => {
      setLoading(true);
    },

    onAfterPrint: () => {
      setLoading(false);
    },
    copyStyles: true,
    pageStyle: () => `
    @page {
      size: A4;
      margin: 1cm;
    }
    .report-print th {
        border-bottom: none;
        background: #EAEEFC;
        height: 35px;
        color:#002E5C;
        font-weight:600;
        font-size: 10px;
        font-family: ${fontFamilies.primary};
        line-height: 120.023%;
        text-transform: uppercase;
        max-width: 33px;
    }
    .report-print th:first-child {
      padding: 16px 20px 16px 16px !important;
    }
    .report-print th:last-child {
      padding: 16px 16px 16px 20px !important;
    }
    .report-print td {
      height: 40px;
      font-family: ${fontFamilies.primary};
      background-color:#ffffff;
      border:none;
      max-width:33px;
      padding: 7px;
      word-break: break-word;
    }
    .report-print td.borderTop {
      border-top: 2px solid #EAEEFC !important;
      color:#002E5C;
      font-weight: 800;
      max-width:33px;
      word-break: break-word;
    }
    .report-print td.table-cell-total {
      border-bottom: 1px solid #81818C !important;
      height: 40px;
      font-family: ${fontFamilies.primary};
      background-color:'#ffffff;
      color: #3D3E46;
      font-size: 13px;
      font-style: normal;
      font-weight: bolder;
      line-height: 120.023%;
      word-break: break-word;
    }
    .report-print .first-cell {
      padding: 16px 7px 16px 16px !important;
    }
    .report-print .last-cell {
      padding: 16px 16px 16px 7px !important;
    }

    .report-print .total-billing-row {
      border-top: 3px solid rgba(129, 129, 140, 1);
      padding-top: 9px;
      display: flex;
      justify-content: space-between;
      align-items: right;
      font-size: 12px;
      font-weight: 600;
      font-family: ${fontFamilies.primary};
      line-height: 120.023%;
      color: #3D3E46;
      padding-bottom: 42px;
      text-align: right;
    }
    .report-print .total-billing-row span {
      font-size: 12px;
      font-weight: 600;
      font-family: ${fontFamilies.primary};
      color: #3D3E46;
  
    }

 
  
    @media print {
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
      } 
     
    }
    `

  });


  const onPrint = async () => {
    printHandler && printHandler !== undefined && await printHandler();
    printPdfHandler();
  }

  return (
    <div className="download-btn export-options">
      <div
        className="feed-export-drop d-flex justify-content-center align-items-center mr-3"
        style={{ width: "120px" }}
      >
        <Dropdown style={{
          minWidth: "130px",
        }}>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="d-flex align-items-center feed-export-dropdown report-export-dropdown justify-content-between"
            disabled={disabled}
            style={buttonStyle}
          >
            <img src={ExportIcon} className="export-icon mr-2" width="10px" />{" "}
            {isLoading ? (
              <span className="mr-3 spinner spinner-primary"></span>
            ) : "Export Data"
            }
            <img src={AngleDown} className=" ml-1" width="15px" />
          </Dropdown.Toggle>


          <Dropdown.Menu
            style={{
              zIndex: 9999,
            }}
          >
            <CsvDownloader
              filename={
                reportFileNameHandler()
              }
              extension=".csv"
              columns={columns}
              datas={sanitizeRows(datas)}
              wrapColumnChar='"'
            >
              <Dropdown.Item>
                <img src={CSVIcon} className="mr-2" />CSV
              </Dropdown.Item>
            </CsvDownloader>
            <Dropdown.Item onClick={downloadExcel}>
              <img src={XLSIcon} className="mr-2" />Excel
            </Dropdown.Item>
            {showPrint && (
              <Dropdown.Item onClick={() => onPrint()}>
                <img src={XLSIcon} className="mr-2" />PDF/Print
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

export default ExportOptions